import script from "./WithdrawalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawalView.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawalView.vue?vue&type=style&index=0&id=1aaa41ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aaa41ce"]])

export default __exports__